module.exports = __webpack_public_path__ + "img/progress.a0f6f006.svg";